// Visit The Stimulus Handbook for more details
// https://stimulusjs.org/handbook/introduction
//
// This example controller works with specially annotated HTML like:
//
// <div data-controller="hello">
//   <h1 data-target="hello.output"></h1>
// </div>

import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ "box", "arrow" ]

  enlarge() {
    this.boxTarget.classList.toggle('hidden');
    if (this.arrowTarget.classList.contains('rotate90')) {
      this.arrowTarget.classList.add('rotate-90')
      this.arrowTarget.classList.remove('rotate90')
    } else {
      this.arrowTarget.classList.add('rotate90')
      this.arrowTarget.classList.remove('rotate-90')
    }
  }
}
